(function () {
  'use strict';

  angular.module('eclipseApp.checkout').filter('formatDate', ['uteLocale', 'buyUtils', function (uteLocale, buyUtils) {

    return function (input, isNoonLabel) {
      var _self = {};

      _self.lang = buyUtils.getAppLang();

      var isEn = (_self.lang === 'en'),
        tFormat = (isEn ? 'hh:mm a' : 'HH:mm'),
        tSuffix = (!isEn ? 'h' : ''),
        time = moment(input).format(tFormat),
        tNoonSuffix = '',
        isNoon = time.substr(0, 4) === '12:0';


      if (isNoonLabel && isNoonLabel === 'isNoonLabel' && isNoon) {
        tNoonSuffix = isEn ? ' (noon)' : ' (midi)';
      }

      return time + ' ' + tSuffix + ' ' + tNoonSuffix;

    };
  }]);
})();
